import type { StoredDinner } from '../store/db.js';

export type DaySlot =
  | { date: string; kind: 'empty' }
  | { date: string; kind: 'meal'; dinner: StoredDinner; spans: number }
  | { date: string; kind: 'continues'; from: string };

/**
 * Map a week's dates onto what each day actually shows.
 *
 * A dinner with spansDays > 1 covers the days after it, so Friday's batch
 * chilli renders as one block reaching into Saturday. An explicitly planned
 * dinner always wins its own day — planning Saturday means you changed your
 * mind about the leftovers.
 */
export function weekCoverage(dinners: StoredDinner[], dates: string[]): DaySlot[] {
  const byDate = new Map(dinners.map((d) => [d.date, d]));
  const slots: DaySlot[] = [];

  for (let i = 0; i < dates.length; i += 1) {
    const date = dates[i]!;
    const own = byDate.get(date);

    if (own) {
      const room = dates.length - i;
      slots.push({ date, kind: 'meal', dinner: own, spans: Math.min(own.spansDays, room) });
      continue;
    }

    // Reach back for a span that covers today, nearest first.
    let covered: string | null = null;
    for (let back = 1; back < i + 1; back += 1) {
      const earlier = byDate.get(dates[i - back]!);
      if (earlier && earlier.spansDays > back) {
        covered = earlier.date;
        break;
      }
    }

    slots.push(covered ? { date, kind: 'continues', from: covered } : { date, kind: 'empty' });
  }

  return slots;
}
